import { h } from 'preact'
import images from '../images'

export default function rankChangeBadgeView (card) {
  if (!card.bucketChangeDirection) return
  return h('img', { class: 'rank-change-badge', src: card.bucketChangeDirection === 'up' ? images['rank-up.svg'] : images['rank-down.svg'] })
}
